import { invokeApi } from "../utils";

export const getCompanyUsersApi = (companyId, page = 1) =>
  invokeApi({ path: `/companies/${companyId}/users`, method: "GET", queryParams: { page } });

export const inviteUserApi = (companyId, postData) =>
  invokeApi({ path: `/companies/${companyId}/users/invite`, method: "POST", postData });

export const getUserByIdApi = (companyId, userId) =>
  invokeApi({ path: `/companies/${companyId}/users/${userId}`, method: "GET" });

export const updateUserApi = (companyId, userId, postData) =>
  invokeApi({ path: `/companies/${companyId}/users/${userId}`, method: "PUT", postData });

export const deleteUserApi = (companyId, userId) =>
  invokeApi({ path: `/companies/${companyId}/users/${userId}`, method: "DELETE" });
